// eslint-disable-next-line import/prefer-default-export
export const getDefaultState = () => ({
  validSession: null,
  sessionData: null,
  logoutUrl: null,
  aviationDocuments: null,
});
